export default __webpack_public_path__ + "static/media/arrow_left.15dea620.svg";